import { FC } from 'react';
import { Control, useController } from 'react-hook-form';

import { ChevronDownIcon } from '../../../../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../../../../components/app-formatted-message/index';
import {
  ComboboxButton,
  ComboboxOptions,
  FormCombobox,
  FormComboboxInput,
  FormComboboxOption,
} from '../../../../../../../components/combobox/index';
import { useLocale } from '../../../../../../../hooks/index';
import { categoryOptions } from '../../../../constants/add-template-form-options.constant';
import { AddTemplateFormSchema } from '../../../../validations/add-template.validation';

export type CategoryComboboxProps = {
  control: Control<AddTemplateFormSchema>;
};

const CategoryOptionList: FC<CategoryComboboxProps> = ({ control }) => (
  <>
    {categoryOptions.map(({ value, labelKey }) => (
      <FormComboboxOption control={control} key={value} name="stepOne.category" value={value}>
        <span className="text-sm font-normal text-gray-700">
          <AppFormattedMessage id={labelKey} />
        </span>
      </FormComboboxOption>
    ))}
  </>
);

export const CategoryCombobox: FC<CategoryComboboxProps> = ({ control }) => {
  const { messagesLocale } = useLocale();
  const { field } = useController({ control, name: 'stepOne.category' });

  const selectedOption = categoryOptions.find((o) => o.value === field.value);
  const displayValue = selectedOption ? messagesLocale[selectedOption.labelKey] : '';

  return (
    <FormCombobox className="relative" control={control} name="stepOne.category">
      <div className="relative">
        <FormComboboxInput
          control={control}
          customValue={() => displayValue}
          icon={<ChevronDownIcon className="mt-3 h-4 w-4 text-gray-500" />}
          name="stepOne.category"
          placeholder={<AppFormattedMessage id="CATEGORY" />}
          readOnly
          wrapperClassName="min-h-[56px]"
        />
        <ComboboxButton className="absolute left-0 top-0 z-1 h-full w-full" />
      </div>
      <ComboboxOptions className="absolute z-20 w-full rounded border border-gray-200 bg-white p-2 shadow-lg">
        <CategoryOptionList control={control} />
      </ComboboxOptions>
    </FormCombobox>
  );
};
